export default {"src":"/_next/static/media/icon_linkedin.2fd3b218.svg","height":24,"width":25};